import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { Subscription } from 'rxjs';

import { StatusService } from './status.service';
import { IStatus } from './status.interfaces';
import { NavController } from '@ionic/angular';
import {
  BillingVisibility,
  FrontendPaidFeatureService,
} from '@tablesready/frontend-paid-feature-alert';
import { NavigationService } from '@tablesready/frontend-navigation';
import { AuthUser } from '@shared/signup/models';

@Component({
  selector: 'status-outlet',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
  standalone: false,
})
export class StatusBarComponent implements OnInit, OnDestroy, OnChanges {
  @Input() user?: AuthUser;
  status: IStatus[] = [];
  statusLength = 0;
  showUsage = false;

  private readonly subscription = new Subscription();

  constructor(
    readonly statusService: StatusService,
    readonly paidService: FrontendPaidFeatureService,
    private readonly navService: NavigationService,
    private readonly navController: NavController,
  ) { }

  navigate(status: IStatus): void {
    if (!status.link) {
      return;
    }

    void this.navController.navigateForward(status.link.href);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['user'] && this.user) {
      this.paidService.setUser(this.user);
    }
  }

  ngOnInit(): void {
    this.subscription.add(this.statusService.status$.subscribe((statusObject) => {
      this.status = [];

      Object.keys(statusObject).forEach((status) => {
        if (!statusObject[status]) {
          return;
        }

        this.status.push(statusObject[status]);
      });

      this.statusLength = this.status.length;
    }));
  }

  close(state: IStatus): void {
    this.statusService.clearStatusById(state.id);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  isReload(status: IStatus): boolean {
    return status.body === 'refresh';
  }

  reload(): void {
    window.location.reload();
  }

  protected readonly BillingVisibility = BillingVisibility;
}
